module.exports = "<div class=\"details\"> <%= data.name %> </div>\r\n"